module.exports = __webpack_public_path__ + "img/ez-slot-ic_deposit_mobile.5941fcdf.png";